
import vue from "vue";
const tabs = () => ["省/直辖市", "", "", ""];
import {
addDay,
setSessionStorage,
getSessionStorage,
removeSessionStorage
} from "@/common/js/utils.js";
import {
getYuBookRegionList,
getRegionTownList,
initWxJSSDK,
appointmentYuBook,
checkYuBookOpenArea,
getPartner
} from "@/common/js/api.js";

import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import { getCookie } from "../common/js/utils";

export default {
directives: {
TransferDom
},
components: {
Tab,
TabItem,
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle,
Divider
},
methods: {
changeCondition() {
this.condition = !this.condition;
},
getResult(val) {
this.results = val ? getResult(this.value) : [];
},
onSubmit(val) {
let self = this;

if (!this.entity.name) {
this.$vux.toast.text("请输入联系人姓名");
return;
}
if (!this.entity.mobile) {
this.$vux.toast.text("请输入联系电话");
return;
} else {
var pattern = /^1[2|3|4|5|6|7|8|9]\d{9}$/;
if (!pattern.test(this.entity.mobile)) {
this.$vux.toast.text("手机号不正确");
return;
}
}
if (!this.entity.areaCode) {
this.$vux.toast.text("请选择所在地区");
return;
}
if (!this.entity.address) {
this.$vux.toast.text("请输入详细地址");
return;
}

if (this.entity.weight == "") {
this.view.toast = true;
this.view.toastText = "请选择重量";
return;
} else if (!this.view.isAreaSupport) {
this.view.toast = true;
this.view.toastText = "当前地址暂未开通服务";
return;
} else if (this.entity.appointTime == "预约时间") {
this.view.toast = true;
this.view.toastText = "请选择预约时间";
return;
}
this.$vux.confirm.show({

title: "提醒您",
content: "确定本次预约吗？",
onCancel() {},
onConfirm() {
self.appointmentYuBook();
}
});
},
appointmentYuBook() {
let self = this;
appointmentYuBook({ data: this.entity }).then(function(data) {
let backData = data;
if( backData.Code!=200 ){
this.view.toast = true;
this.view.toastText = backData.Message;
return;
}
self.$vux.confirm.show({

title: "提醒您",
content: "本次预约完成",
onCancel() {
window.location.reload();

},
onConfirm() {
window.location.reload();

}
});

});
},
onChange(v) {},

weightChange(v) {
console.log(v);
},
confirmWeight() {
if (this.view.weightDefault == 0) {
this.view.toast = true;
this.view.toastText = "5KG以下(暂不回收)";
} else {
this.view.openWeightPicker = !this.view.openWeightPicker;
this.entity.weight = this.getSelectValue(
this.view.weightDefault,
this.weights[0]
);
this.view.weightText = this.getSelectText(
this.view.weightDefault,
this.weights[0]
);
}
},
pickWeight(item) {
if (item.status == 0) {
return;
}
this.view.weightDefault = item.value;
},
getSelectText(val, ls) {
for (var i = 0; i < ls.length; i++) {
if (ls[i].value == val) {
return ls[i].name;
}
}
return "";
},
getSelectValue(val, ls) {
for (var i = 0; i < ls.length; i++) {
if (ls[i].value == val) {
return ls[i].value;
}
}
return "";
},
confirmTime() {
this.view.openTimePicker = !this.view.openTimePicker;
this.entity.appointTime = this.view.appointTimeDefault[0];





},
openPickAddress() {
setSessionStorage("pickAddress", "1");
this.$router.push({
path: '/usercenter/addressList',
query: { type: 'choice', partnerId: this.partnerId }
})
},











checkYuBookOpenArea(areaCode) {
let self = this;
self.view.isAreaSupport = false;
checkYuBookOpenArea({ data: { areaCode: areaCode } }).then(function(
data
) {
if (data.Code == 200) {
self.view.isAreaSupport = true;
self.entity.province = self.choiceItems[ 0 ].name;  
self.entity.city = self.choiceItems[ 1 ].name;  
self.entity.area = self.choiceItems[ 2 ].name;  
self.entity.street = self.choiceItems[ 3 ].name;  
self.entity.areaCode = self.choiceItems[self.choiceItems.length - 1].code;  

for (var i = 0; i < self.choiceItems.length; i++) {
self.view.areaCodeText += self.choiceItems[i].name;
}
}
});
},

changeName(v) {
if (!v) {
return;
}
let self = this;
setTimeout(function() {
self.entity.name = self.entity.name.replace(
/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
""
);
self.$forceUpdate();

}, 500);
},
changeAddress(v) {
if (!v) {
return;
}
let self = this;
setTimeout(function() {
self.entity.address = self.entity.address.replace(
/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
""
);
self.$forceUpdate();

}, 500);
},

changeTab(idx) {
let self = this;
if (!this.choiceItems[idx] || !this.choiceItems[idx].parentCode) {
return;
}
self.currentParentCode = this.choiceItems[idx].parentCode;
if (idx < 3) {
self.initCurrentRegions();
} else {
getRegionTownList({ data: { parentId: self.currentParentCode } }).then(
function(data) {
self.currentRegions = data.Content;
}
);
}
},








getChoiceAddress() {
let self = this;
let areaCode = self.choiceItems[this.choiceItems.length - 1].code;  







this.checkYuBookOpenArea( areaCode );
},
checkThis(item) {
let self = this;

if (item.rank == 2) {
this.choiceItems = [];
this.choiceItems.push(item);
} else if (item.rank == 3) {
if (this.choiceItems.length > 1) {
this.choiceItems.splice(1, this.choiceItems.length - 1);
}
this.choiceItems.push(item);
} else if (item.rank == 4) {
if (this.choiceItems.length > 2) {
this.choiceItems.splice(2, this.choiceItems.length - 2);
}
this.choiceItems.push(item);
self.currentRegions = [];
getRegionTownList({ data: { parentId: item.code } }).then(function(
data
) {
self.currentRegions = data.Content;
});
} else if (item.rank == 5) {
if (this.choiceItems.length > 3) {
this.choiceItems.splice(3, 1);
}
this.choiceItems.push(item);
self.view.openAddressPicker = false;
self.getChoiceAddress();
}
let arr = [];
for (var i = 0; i < this.choiceItems.length; i++) {
arr.push(this.choiceItems[i].name);
}
if (arr.length == 1) {
arr.push("市");
} else if (arr.length == 2) {
arr.push("区/县");
} else if (arr.length == 3) {
arr.push("街道/镇");
}
let len = arr.length;

this.currentTabIndex = len - 1;

for (var i = 0; i < 4 - len; i++) {
arr.push("");
}

this.choiceList = arr;


if (item.rank >= 2 && item.rank < 4) {
self.currentParentCode = item.code;
self.initCurrentRegions();
}
},
initCurrentRegions() {
let self = this;
let arr = [];
for (var i = 0; i < self.regions.length; i++) {
if (self.currentParentCode == self.regions[i].parentCode) {
arr.push(self.regions[i]);
}
}
self.currentRegions = arr;
},
getYuBookRegionList() {
let self = this;
getYuBookRegionList().then(function(data) {
self.regions = data.Content;
self.currentParentCode = "Area_China";
self.initCurrentRegions();
});
},




initShare() {
let self = this;
self.$wechat.onMenuShareTimeline({
title: self.share.shareTitle, // 分享标题
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
success: function() {















},
cancel: function() {

}
});
self.$wechat.onMenuShareAppMessage({
title: self.share.shareTitle,
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
desc: self.share.shareDesc,
type: "link",
dataUrl: "",
success: function() {




},
cancel: function() {

}
});
}
},
data() {
return {
fromWhere: this.$route.query.fromWhere,
activityId: this.$route.query.activityId,
partner: {},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: "",
extInfo: undefined
},
view: {
openWeightPicker: false,
toast: false,
toastText: "",
openTimePicker: false,
openAddressPicker: false,
weightText: "重量",
appointTimeDefault: [],
weightDefault: "2",
address: "",
areaCode: "",
isAreaSupport: false,
areaCodeText:""
},
entity: {
weight: "",
appointTime: "预约时间",
name: "",
areaCode: "",
mobile: "",

province: "",
city: "",
area: "",
street: "",
address: "",
memo:""
},
weights: [
[
{ name: "5KG以下(暂不回收)", value: "0", status: 0 },
{ name: "5-15KG(约17件)", value: "1", status: 1 },
{ name: "15-25KG(约37件)", value: "2", status: 1 },
{ name: "25-35KG(约60件)", value: "3", status: 1 },
{ name: "35KG以上(约75件以上)", value: "4", status: 1 }
]
],
times: [],
share: {
shareTitle: "闲置衣物回收",
shareDesc: "闲置衣物回收",
shareUrl: ""
},
partnerId: "",
appointImage: "",
btnStyle: "",
bannerImage: "",
choiceList: tabs(),
choiceItems: [],
regions: [],
currentRegions: [],
currentParentCode: "Area_China",
appointTimeDefault: [],
currentTabIndex: 0
};
},
created() {


let self = this;
self.partnerId = this.$route.query.partnerId;
self.entity.partnerId = self.partnerId;
if (this.$route.query.autoSupport) {
self.entity.autoSupport = this.$route.query.autoSupport;
}

var sharePartner = self.partnerId
? "&invitePartnerId=" + self.partnerId + "&partnerId=" + self.partnerId
: "";
if (this.$route.query.partnerId) {
getPartner({ data: { partnerId: self.partnerId } }).then(function(data) {
console.log(data)
if (data.Content) {
self.partner = data.Content;
if (data.Content.appointImages) {
self.appointImage = data.Content.appointImages;
} else {
self.appointImage = "../../static/images/intro2.jpg?v=2";
}
console.log(self.appointImage);

if (self.partner.color) {
self.btnStyle = "background:#" + self.partner.color + "!important";
}
if (self.partner.banner) {
self.bannerImage = self.partner.banner;
} else {
self.bannerImage = "../../static/images/ad2.jpg";
}
} else {
self.appointImage = "../../static/images/intro2.jpg?v=2";
self.bannerImage = "../../static/images/ad2.jpg";
}
});
} else {
















self.appointImage = "../../static/images/intro2.jpg?v=2";
self.bannerImage = "../../static/images/ad2.jpg";


}

self.share.shareUrl =
window.location.protocol +
"//" +
window.location.hostname +
"/menu/appointment/" +
getCookie("authorizer_appid") +
"?k=1" +
sharePartner;

initWxJSSDK();
vue.wechat.ready(function(res) {
self.initShare();
});
let days = [];
let now = new Date();
let j = 0
for (var i = 0; i < 7; i++) {
let d = addDay(now, i + 1);
let date = d.Format("yyyy-MM-dd")
const dateArr = date.split('-')
const month = parseInt(dateArr[1])
const day = parseInt(dateArr[2])

if (month == 2 && day >= 11 && day <= 18) {
d = addDay('2021-02-18', j)
date = d.Format("yyyy-MM-dd")
j++
}

if (i == 0) {
days.push(date);
this.view.appointTimeDefault.push(date);
} else {
days.push(date);
}
}
this.times.push(days);
},
mounted() {

let self = this;
this.getYuBookRegionList();
},
activated() {

}
};



// WEBPACK FOOTER //
// ./src/components/bookThr.vue